import React from 'react';

import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

import { FiltersContainer, FiltersTitle } from 'common-ui/filters';
import { ContactBookFilters } from 'core/lib';
import { ContactBookType } from 'core/lib/constants/contactBook';
import { TypeOptions } from 'core/lib/constants/selects';

type TagsFilterProps = {
  onChange: (filters: Partial<ContactBookFilters>) => void;
  filters: ContactBookType[] | undefined;
};

const TagsFilter = ({ onChange, filters }: TagsFilterProps) => {
  const { t } = useTranslation();

  return (
    <FiltersContainer>
      <FiltersTitle title={t('contactBook:filters.type')} />
      <Select
        mode="multiple"
        className="w-full"
        allowClear
        showSearch={false}
        options={TypeOptions}
        value={filters}
        placeholder={t('global:placeholders.selectType', { type: t('contactBook:filters.type') })}
        onChange={(type) => onChange({ type })}
      />
    </FiltersContainer>
  );
};

export default TagsFilter;
